module.exports = __webpack_public_path__ + "static/media/trending_flat_FILL0_wght400_GRAD0_opsz48.973703aa.svg";